// extracted by mini-css-extract-plugin
module.exports = {"paragraph":"terms_paragraph__RnOq3"};